var map = {
	"./en.json": [
		51114,
		1114
	],
	"./es.json": [
		68893,
		8893
	],
	"./fr-falc.json": [
		88898,
		8898
	],
	"./fr.json": [
		9039,
		9039
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 24872;
module.exports = webpackAsyncContext;